import Image from "next/image";
import { Text } from "@/components/ui/text";

interface HeaderProps {
  name: string;
  logo?: string;
}

export default function Header({ name, logo }: HeaderProps) {
  const initials = name
    .split(" ")
    .map((word) => word[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

  return (
    <div className="flex items-center gap-3">
      {logo ? (
        <Image
          src={logo}
          alt={name}
          width={0}
          height={0}
          className="h-8 w-auto object-contain"
          unoptimized
        />
      ) : (
        <div className="flex size-8 items-center justify-center rounded bg-primary text-xs text-white">
          {initials}
        </div>
      )}
      <Text variant="large" className="text-base font-semibold">
        {name}
      </Text>
    </div>
  );
}
